import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import _Aux from "../../_Aux";
import styles from "./ChartDrawing.css";
import webStorageManager from "../../../services/managers/web-storage";
import mathManager from "../../../services/managers/math";
import {
  CHART_CTT,
  CHART_SPREAD,
  CHART_BID_ASK_QUANTITY,
  CHART_TYPE_SCATTER_PLOT,
  CHART_TYPE_LINE,
  CHART_TYPE_AREA_MIRRORED,
  GRANULARITIES,
  ZONES,
  PRODUCTS,
  CHARTS
} from "../../../services/managers/constants";
import { TOOLTIP_ENLARGE } from "../../../services/managers/string-literals";
import commonRenderer from "../../../services/renderers/common";
import costToTradeScatterPlotRenderer from "../../../services/renderers/cost-to-trade-scatter-plot";
import spreadLineRenderer from "../../../services/renderers/spread-line";
import bidAskQuantityAreaMirroredRenderer from "../../../services/renderers/bid-ask-quantity-area-mirrored";
import costToTradeScatterPlotWithSpreadLineRenderer from "../../../services/renderers/cost-to-trade-scatter-plot-with-spread-line";
import costToTradeScatterPlotWithBidAskQuantityAreaMirroredRenderer from "../../../services/renderers/cost-to-trade-scatter-plot-with-bid-ask-quantity-area-mirrored";
import spreadLineWithBidAskQuantityAreaMirroredRenderer from "../../../services/renderers/spread-line-with-bid-ask-quantity-area-mirrored";
import pagePreloaderManager from "../../../services/managers/page-preloader";
import Modal from "../../Common/Modal/Modal";
import ChartLegend from "../../Analytics/ChartLegend/ChartLegend";

class ChartDrawing extends React.Component {
  constructor() {
    super();
    this.state = {
      enlarge: false, // For enlarging of chart
      resize: false // For resizing or rotation of browser
    };
    this.onEnlargeCloseClick = this.onEnlargeCloseClick.bind(this);
    this.escFunction = this.escFunction.bind(this);
    this.bindResizeChangeEvent = this.bindResizeChangeEvent.bind(this);
    this.handleResizeChangeEvent = this.handleResizeChangeEvent.bind(this);
  }

  initRendering() {
    let drawingContainerElementId = commonRenderer.getDrawingContainerElementId(
      this.props.whiteboardIndex,
      this.props.drawingIndex,
      this.props.drawing.__id
    );

    let margin = { top: 5, right: 50, bottom: 35, left: 50 };
    let width = document.getElementById(drawingContainerElementId).clientWidth - margin.left - margin.right;
    let height = 500 - margin.top - margin.bottom;

    let granularityObj = _.find(GRANULARITIES, { Code: this.props.selectedGranularity });
    let zoneObj = _.find(ZONES, { Code: this.props.drawing.selectedZone });

    // Contruct input parameters required by renderers
    let rendererParams = {};
    rendererParams.data = webStorageManager.get(this.props.drawing.__id);
    rendererParams.drawingContainerElementId = drawingContainerElementId;
    rendererParams.uniqueKey = this.props.drawing.__id;
    rendererParams.selectedLayers = this.props.selectedLayers;
    rendererParams.dimensions = { margin, width, height };
    rendererParams.zoneOffset = zoneObj.Offset;
    rendererParams.zoneName = zoneObj.Name;
    rendererParams.zoneTiming = zoneObj.Timing;
    rendererParams.tickFormat = granularityObj.TickFormat;
    rendererParams.granularityCode = granularityObj.Code;
    rendererParams.primaryChart = this.props.selectedPrimaryChart;

    // Now call required renderer...

    if (
      (this.props.selectedPrimaryChart === CHART_CTT &&
        this.props.selectedPrimaryChartType === CHART_TYPE_SCATTER_PLOT &&
        this.props.selectedComparisonChart === CHART_SPREAD &&
        this.props.selectedComparisonChartType === CHART_TYPE_LINE) ||
      (this.props.selectedComparisonChart === CHART_CTT &&
        this.props.selectedComparisonChartType === CHART_TYPE_SCATTER_PLOT &&
        this.props.selectedPrimaryChart === CHART_SPREAD &&
        this.props.selectedPrimaryChartType === CHART_TYPE_LINE)
    ) {
      // Cost To Trade (Scatter) + Spread (Line)
      costToTradeScatterPlotWithSpreadLineRenderer.render(rendererParams);
    } else if (
      (this.props.selectedPrimaryChart === CHART_CTT &&
        this.props.selectedPrimaryChartType === CHART_TYPE_SCATTER_PLOT &&
        this.props.selectedComparisonChart === CHART_BID_ASK_QUANTITY &&
        this.props.selectedComparisonChartType === CHART_TYPE_AREA_MIRRORED) ||
      (this.props.selectedComparisonChart === CHART_CTT &&
        this.props.selectedComparisonChartType === CHART_TYPE_SCATTER_PLOT &&
        this.props.selectedPrimaryChart === CHART_BID_ASK_QUANTITY &&
        this.props.selectedPrimaryChartType === CHART_TYPE_AREA_MIRRORED)
    ) {
      // Cost To Trade (Scatter) + Bid Ask Quantity (Area)
      costToTradeScatterPlotWithBidAskQuantityAreaMirroredRenderer.render(rendererParams);
    } else if (
      (this.props.selectedPrimaryChart === CHART_SPREAD &&
        this.props.selectedPrimaryChartType === CHART_TYPE_LINE &&
        this.props.selectedComparisonChart === CHART_BID_ASK_QUANTITY &&
        this.props.selectedComparisonChartType === CHART_TYPE_AREA_MIRRORED) ||
      (this.props.selectedComparisonChart === CHART_SPREAD &&
        this.props.selectedComparisonChartType === CHART_TYPE_LINE &&
        this.props.selectedPrimaryChart === CHART_BID_ASK_QUANTITY &&
        this.props.selectedPrimaryChartType === CHART_TYPE_AREA_MIRRORED)
    ) {
      //  Spread (Line) + Bid Ask Quantity (Area)
      spreadLineWithBidAskQuantityAreaMirroredRenderer.render(rendererParams);
    } else if (this.props.selectedPrimaryChart === CHART_CTT && this.props.selectedPrimaryChartType === CHART_TYPE_SCATTER_PLOT) {
      // Cost To Trade (Scatter)
      costToTradeScatterPlotRenderer.render(rendererParams);
    } else if (this.props.selectedPrimaryChart === CHART_SPREAD && this.props.selectedPrimaryChartType === CHART_TYPE_LINE) {
      // Spread (Line)
      spreadLineRenderer.render(rendererParams);
    } else if (this.props.selectedPrimaryChart === CHART_BID_ASK_QUANTITY && this.props.selectedPrimaryChartType === CHART_TYPE_AREA_MIRRORED) {
      // Bid Ask Quantity (Area Mirrored)
      bidAskQuantityAreaMirroredRenderer.render(rendererParams);
    }
  }

  bindResizeChangeEvent() {
    if ("onresize" in window) {
      window.addEventListener("resize", this.handleResizeChangeEvent, false);
    }
  }

  onEnlargeCloseClick() {
    this.setState({ enlarge: false });
  }

  onEnlargeClick() {
    pagePreloaderManager.show("Enlarging chart");
    this.setState({ enlarge: true });
  }

  escFunction(event) {
    // Close enlarge modal on pressing Esc
    if (event.keyCode === 27 && this.state.enlarge) {
      this.onEnlargeCloseClick();
    }
  }

  handleResizeChangeEvent() {
    this.setState({ resize: !this.state.resize });
  }

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);

    this.initRendering();
    // Orientation chage or resizing in mobile devices
    this.bindResizeChangeEvent();
  }

  componentDidUpdate() {
    // Destroy the previous drawing's DOM structure when new drawing is being rendered
    commonRenderer.destroyDrawing(
      commonRenderer.getDrawingContainerElementId(this.props.whiteboardIndex, this.props.drawingIndex, this.props.drawing.__id),
      false
    );
    this.initRendering();
    pagePreloaderManager.hide();
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.drawing.__change_detection_key !== nextProps.drawing.__change_detection_key ||
      this.state.enlarge !== nextState.enlarge ||
      this.state.resize !== nextState.resize
    );
  }

  componentWillUnmount() {
    // Remove cached chart data when unmounting the component
    // This makes sure no unwanted data is left in memory
    // when this component is unmounted
    webStorageManager.remove(this.props.drawing.__id);

    // Remove all DOM nodes, including SVG
    // This makes sure no detached DOM nodes are left in memory
    // when this component is unmounted
    commonRenderer.destroyDrawing(
      commonRenderer.getDrawingContainerElementId(this.props.whiteboardIndex, this.props.drawingIndex, this.props.drawing.__id)
    );

    // Remove all event listeners
    document.removeEventListener("keydown", this.escFunction, false);
    document.removeEventListener("resize", this.handleResizeChangeEvent, false);
  }

  render() {
    let lotSizeValDoc = this.props.drawing.lotSizeVal ? (
      <label>
        <strong>
          {"Lot Size: "} {mathManager.toUSANumberFormat(this.props.drawing.lotSizeVal)}
        </strong>
      </label>
    ) : null;

    let drawingContainerElementId = commonRenderer.getDrawingContainerElementId(
      this.props.whiteboardIndex,
      this.props.drawingIndex,
      this.props.drawing.__id
    );

    let enlargeDoc =
      this.props.selectedCostToTradeLotSizes.length > 1 ? (
        <button
          className={"btn btn--link btn--enlarge " + styles["btn-enlarge"]}
          onClick={() => this.onEnlargeClick(this.props.whiteboardIndex, this.props.drawingIndex, this.props.drawing.__id)}
          title={TOOLTIP_ENLARGE}>
          <i className="fa fa-search-plus" aria-hidden="true" /> Enlarge
        </button>
      ) : null;

    let legendDoc = (
      <ChartLegend
        drawingsLen={this.props.drawingsLen}
        isObsolete={this.props.isObsolete}
        selectedPrimaryChart={this.props.selectedPrimaryChart}
        selectedPrimaryChartType={this.props.selectedPrimaryChartType}
        selectedComparisonChart={this.props.selectedComparisonChart}
        selectedComparisonChartType={this.props.selectedComparisonChartType}
      />
    );

    // Get the tick-size value of selectedProduct from Products
    let tickSizeValue = PRODUCTS.find((data) => data.productCode === this.props.selectedProduct).tickSizeValue;

    // To hide and show tick size value
    let DisplayTickSizeValue = CHARTS.find(
      (data) => data.Code === this.props.selectedPrimaryChart || data.Code === this.props.selectedComparisonChart
    ).DisplayTickSizeValue;

    // Returning tick size value
    let tickSizeValueDoc = DisplayTickSizeValue ?
      (<div className={styles["tick-size-value"]}>
        {tickSizeValue}
      </div>) : null;

    return this.state.enlarge ? (
      <Modal>
        <div className={"modal-content-container " + styles["enlarge-modal-container"]}>
          <header className="modal__header modal-header" aria-labelledby="modal__title">
            <h3>{"Lot Size: " + mathManager.toUSANumberFormat(this.props.drawing.lotSizeVal)}</h3>
            <button className="modal__close btn btn--transparent js-modal-close" aria-label="close" onClick={this.onEnlargeCloseClick}>
              <i className="icon-cme-card-close icon--medium" />
            </button>
          </header>

          <div className={"modal-content " + styles["modal--content"]}>
            <div id={drawingContainerElementId} className={styles["drawing-container"]} />
            {legendDoc}
            {tickSizeValueDoc}
          </div>
        </div>
      </Modal>
    ) : (
        <_Aux>
          {lotSizeValDoc}
          <div id={drawingContainerElementId} className={styles["drawing-container"]} />
          <div>
            <div className={styles["pull-left"]}>{legendDoc}</div>
            <div className={styles["pull-right"]}>{enlargeDoc}</div>
          </div>
          {tickSizeValueDoc}
        </_Aux>
      );
  }
}

ChartDrawing.propTypes = {
  whiteboardIndex: PropTypes.number.isRequired
};

const mapStateToProps = (state) => ({
  selectedProduct: state.analytics.selectedProduct
});

export default connect(mapStateToProps, null)(ChartDrawing);



// WEBPACK FOOTER //
// ./src/components/Analytics/ChartDrawing/ChartDrawing.js